import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
// import { ChatRoomPage } from '../chat-room/chat-room';
// import { HomePage } from '../home/home';
// import { LeadsTabsPage } from '../leads-tabs/leads-tabs';
// import { LeadsPage } from '../leads/leads';
// import { ListPage } from '../list/list';

/**
 * Generated class for the TabsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-tabs',
  templateUrl: 'tabs.html',
})
export class TabsPage {
  tab1Root = 'HomePage';
  tab2Root = 'StartLeadsPage';
  tab3Root = 'ListPage';
  // tab4Root = 'ChatRoomPage';
  tab4Root = 'ChatChaptersPage';
  tab5Root = 'LeadsTabsPage';

  selectedIndex: any;

  constructor(public navCtrl: NavController, public navParams: NavParams,) {
    this.selectedIndex = this.navParams.get('tabIndex') || 0;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TabsPage');
    // this.oneSignal.getIds().then(identity => {
    //   // alert('')
    //   localStorage.setItem("player_id", identity.userId);
    //     var userData = JSON.parse(localStorage.getItem('user_data'));
    //     var delarray = {
    //       "player_id": identity.userId,
    //       'country_id': userData[0].usr_country,
    //       'user_id': userData[0].usr_id
    //     }
    //     this.apiProvider.updatepublicplayerid(delarray).subscribe((res) => {
    //       var playeridresult = [];
    //       playeridresult.push(res);
    //       if (playeridresult[0].status == 200) {
    //         localStorage.setItem("player_i_ind", '0');
    //       }
    //     })
    // });
  }

}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts